import { Modals } from './components/Modals';
import { MainNav } from './components/MainNav';
import { CardGroup } from './components/CardGroup';
import { ContactMap } from './components/ContactMap';
import { ScrollObserver } from './components/ScrollObserver';
import { RequestFormWrapper } from './components/RequestFormWrapper';

document.addEventListener('DOMContentLoaded', () => {
    new MainNav();
    new ScrollObserver();
    new Modals();

    // Check links on the page for PDF links in call to action boxes
    const ctaButtons = [...document.querySelectorAll('.cta--btn')];

    ctaButtons.forEach(btn => {
        const a = btn.querySelector('a');
        const pattern = /\.pdf/;

        if (a) {
            if (pattern.test(a.href)) {
                const title = btn.parentElement.parentElement.querySelector('h3');
                const description = btn.parentElement.parentElement.querySelector('p');
                const downloadTitle = `${title.textContent}${description ? ` – ${description.textContent}` : ''}`;
                a.setAttribute('download', downloadTitle);
            }
        }
    });

    // Map for contact page
    const map = document.querySelector('#map');
    if (map) {
        new ContactMap(map)
    }

    // Expandable cards
    const itemList = document.querySelector('.item-list');

    if (itemList) {
        new CardGroup();
    }

    // Request form
    const requestBtn = document.querySelector('.request-btn');

    if (requestBtn) {
        new RequestFormWrapper();
    }

    // Equalize PDF link sizes
    const pdfLinks = [...document.querySelectorAll('.main :link')].filter(l => /.pdf$/.test(l.href));

    if (pdfLinks) {
        const w = pdfLinks.reduce((width, link) => Math.max(width, link.getBoundingClientRect().width), 0);
        if (w !== 0) {
            pdfLinks.forEach(l => l.style.width = `${w}px`);
        }
    }

    // Do some animation on the hero
    setTimeout(() => {
        document.body.classList.add('show-hero');
    }, 500);

    if (document.querySelector('.post-password-form')) {
        document.querySelector('.post-password-form input').focus();
    }
});
